module.exports = __webpack_public_path__ + "img/warning_orange.fe304396.svg";